export enum ModuleName {
    // --- Top-level  --------------------------------------------------------
    Dashboard = 'dashboard',
    VinSession = 'vin_session_dashboard',
    NotFound = 'not_found',
    PublicLanding = 'public_landing',

    // --- STIS / docs --------------------------------------------------------
    Stis = 'stis',
    StisServiceDiagnostics = 'stis_service_diagnostics',
    StisTroubleshootingSearch = 'stis_troubleshooting_search',
    StisOnboard = 'stis_onboard',
    Docs = 'docs',
    Preview = 'preview',
    Onboard = 'onboard',

    // --- QMRs / NQRs / escalations / investigations -------------------------
    Qmrs = 'qmrs',
    QmrsDashboard = 'qmrs_dashboard',
    QmrsAdvancedSearch = 'qmrs_advanced_search',
    QmrsCsvExport = 'qmrs_csv_export',
    Nqrs = 'nqrs',
    Escalations = 'escalations',
    Investigations = 'investigations',

    // --- Fail codes ---------------------------------------------------------
    FailCodeCsvExport = 'fail_code_csv_export',

    // --- Techline  ----------------------------
    Techline = 'techline',

    // --- VIN-scoped sub-routers ---------------------------------------------
    Bmis = 'bmis',
    RepairOrders = 'repair_orders',
    Campaigns = 'campaigns',
    CidCvnCheck = 'cid_cvn_check',
    Cvt = 'cvt',
    Ssm5 = 'ssm5',

    // --- Feedback -----------------------------------------------------------
    Feedback = 'feedback',

    // --- User articles ------------------------------------------------------
    UserArticles = 'user_articles',

    // --- Administration -----------------------------------------------------
    Administration = 'administration',
    AdminHub = 'admin_hub',
    AdminContentSettings = 'admin_content_settings',
    AdminDsqmsReassignment = 'admin_dsqms_reassignment',
    AdminReports = 'admin_reports',
    AdminEntities = 'admin_entities',
    AdminFailCodeTeams = 'admin_fail_code_teams',
    AdminFeedback = 'admin_feedback',
    AdminPublications = 'admin_publications',
    AdminRetailers = 'admin_retailers',
    AdminSynonyms = 'admin_synonyms',
    AdminToughbookAttachments = 'admin_toughbook_attachments',
    AdminUsers = 'admin_users',
    AdminWorksheets = 'admin_worksheets',

    // --- Public --------------------------------------------------------------
    PrivacyPolicy = 'privacy_policy',
    TermsConditions = 'terms_conditions',
    Faq = 'faq',
    ContactUs = 'contact_us',
    EmergencyGuides = 'emergency_guides',
    DiagnosticToolInfo = 'diagnostic_tool_info',

    // ---  Reports / settings -------------------------------------------------
    Reports = 'reports',
    Settings = 'settings',
}
